import styled from 'styled-components';

export const GameList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GameRow = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;

  & > a {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    background: var(--felt-deep);
    color: var(--ink);
    text-decoration: none;
  }
`;

export const Status = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.$yourMove ? 'var(--accent)' : 'var(--muted)'};
`;
